import React from "react";
import {
  ExclamationMarkYellow,
  SubcriptionsBookkeepingImg,
  SubscriptionInvoicingImg,
} from "../../../assets/Icon/headerCicon";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import {
  BppCardBgIconDown,
  BppCardBgIconUp,
} from "../../../assets/Icon/BppIcon";
import { useNavigate } from "react-router-dom";

interface Props {
  subscription: any;
  setModalOpen: (data: any) => void;
  setCanceledData: (data: any) => void;
}

const SubscriptionCard = ({
  subscription,
  setModalOpen,
  setCanceledData,
}: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();

  return (
    <div>
      <Box
        sx={{
          backgroundColor: "#f8f9fa",
          padding: "12px",
          position: "relative",
        }}
      >
        {/* Main Title */}
        <Box
          sx={{
            backgroundColor: "#ffffff",
            borderRadius: "10px",
            borderTopLeftRadius: "20px",
            borderBottomRightRadius: "20px",
            padding: "2rem",
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
            gap: "2rem",
            position: "relative",
            // maxWidth: "800px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            paddingBottom: "40px",
            overflow: "hidden",
          }}
        >
          {/* Background Icons */}
          <Box sx={{ position: "absolute", bottom: -6, right: 0 }}>
            <BppCardBgIconDown />
          </Box>
          <Box sx={{ position: "absolute", top: -2, left: 0 }}>
            <BppCardBgIconUp />
          </Box>
          <div
            style={{
              display: isMobile ? "grid" : "flex",
              justifyContent: "space-between",
              width: "100%",
              marginLeft: "10px",
              marginRight: "15px",
            }}
          >
            <div
              style={{
                display: isMobile ? "grid" : "flex",
                justifyContent: "center",
                gap: "30px",
                marginTop: "20px",
              }}
            >
              {subscription?.title === "Invoicing" ? (
                <SubscriptionInvoicingImg />
              ) : (
                <SubcriptionsBookkeepingImg />
              )}

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    display: isMobile ? "grid" : "flex",
                    alignItems: "center",
                    gap: isMobile ? 5 : 15,
                    marginTop: -5,
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "24px",
                      fontWeight: 500,
                      color: "#000",
                    }}
                  >
                    {subscription?.title}
                  </Typography>
                  {subscription?.is_canceled &&
                  subscription?.status === "cancelled" ? (
                    <div
                      style={{
                        background: "#F20F0014",
                        color: "#F20F00",
                        width: "fit-content",
                        paddingLeft: "19px",
                        paddingRight: "19px",
                        paddingTop: "1px",
                        paddingBottom: "1px",
                        borderRadius: "100px",
                        fontSize: "16px",
                        fontWeight: 500,
                        display: "flex",
                        gap: "4px",
                        alignItems: "center",
                        marginTop: "4px",
                      }}
                    >
                      <span style={{ fontSize: "18px", paddingBottom: "3px" }}>
                        ●
                      </span>{" "}
                      Cancelled
                    </div>
                  ) : (
                    <div
                      style={{
                        background: subscription?.amount
                          ? "#3DC82633"
                          : "#E7AB1233",
                        color: subscription?.amount ? "#3DC826" : "#E7AB12",
                        width: "fit-content",
                        paddingLeft: "19px",
                        paddingRight: "19px",
                        paddingTop: "1px",
                        paddingBottom: "1px",
                        borderRadius: "100px",
                        fontSize: isMobile ? "12px" : "16px",
                        fontWeight: 500,
                        display: "flex",
                        gap: "4px",
                        alignItems: "center",
                        marginTop: "4px",
                        marginBottom: isMobile ? "10px" : 0,
                      }}
                    >
                      <span
                        style={{
                          fontSize: isMobile ? "14px" : "18px",
                          paddingBottom: "3px",
                        }}
                      >
                        ●
                      </span>{" "}
                      {subscription?.status === "active" && "Active"}
                      {(subscription?.status === "not_subscribed" ||
                        subscription?.status === "past_due") &&
                        "Not Subscribed"}
                      {subscription?.status === "cancel_scheduled" && "Active"}
                    </div>
                  )}
                </div>
                {subscription?.amount ? (
                  <div>
                    <div
                      style={{
                        color: "#2977CC",
                        marginTop: -3,
                      }}
                    >
                      <span
                        style={{
                          fontSize: "32px",
                          fontWeight: 800,
                        }}
                      >
                        ${subscription?.amount}
                      </span>
                      <span
                        style={{
                          fontSize: "18px",
                        }}
                      >
                        /{subscription?.billing_cycle?.toLowerCase()}
                      </span>
                    </div>
                    <div
                      style={{
                        marginTop: "3px",
                        fontSize: isMobile ? "14px" : "16px",
                      }}
                    >
                      <span>
                        Last Payment:{" "}
                        <span style={{ color: "#6C6F71" }}>
                          {subscription?.last_payment_display}
                        </span>{" "}
                      </span>{" "}
                      {!subscription?.is_canceled && (
                        <span
                          style={{
                            marginLeft: isMobile ? "5px" : "10px",
                            marginRight: isMobile ? "5px" : "10px",
                            color: "#6C6F71",
                          }}
                        >
                          |
                        </span>
                      )}
                      {!subscription?.is_canceled && (
                        <span>
                          Next Renewal:{" "}
                          <span style={{ color: "#6C6F71" }}>
                            {subscription?.next_renewal_display}
                          </span>
                        </span>
                      )}
                    </div>
                    <div
                      style={{
                        background: "#EAF1FA",
                        color: "#2977CC",
                        width: "fit-content",
                        fontSize: "14px",
                        paddingLeft: "16px",
                        paddingRight: "16px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                        borderRadius: "7px",
                        marginTop: "12px",
                      }}
                    >
                      Billing Cycle: {subscription?.billing_cycle}
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      color: "#6C6F71",
                      fontSize: "16px",
                      marginTop: "15px",
                    }}
                  >
                    You haven’t subscribed to {subscription?.title} yet. Unlock
                    reports and
                    <br />
                    smart categorization.
                  </div>
                )}
              </Box>
            </div>
            {subscription?.amount ? (
              <button
                style={{
                  background: "#EAF1FA",
                  color: "#2977CC",
                  fontSize: "14px",
                  fontWeight: 600,
                  paddingLeft: "53px",
                  paddingRight: "53px",
                  paddingTop: "14px",
                  paddingBottom: "14px",
                  borderRadius: "7px",
                  border: "none",
                  height: "fit-content",
                  marginTop: "16px",
                  cursor: "pointer",
                  marginBottom: isMobile ? "10px" : 0,
                  display: subscription?.is_canceled ? "none" : "block",
                }}
                onClick={() => {
                  setModalOpen(true);
                  setCanceledData(subscription);
                }}
              >
                Cancel
              </button>
            ) : (
              <button
                style={{
                  marginBottom: isMobile ? "10px" : 0,
                  color: "#fff",
                  background: "#2977CC",
                  fontSize: "14px",
                  fontWeight: 600,
                  paddingLeft: "45px",
                  paddingRight: "45px",
                  paddingTop: "14px",
                  paddingBottom: "14px",
                  borderRadius: "7px",
                  border: "none",
                  height: "fit-content",
                  marginTop: "16px",
                  cursor: "pointer",
                  display: subscription?.is_canceled ? "none" : "block",
                }}
                onClick={() => {
                  if (subscription?.title === "Invoicing") {
                    navigate("/tools/invoices");
                  } else {
                    navigate("/tools/bookkeeper");
                  }
                }}
              >
                Buy Now
              </button>
            )}
            {subscription?.is_canceled &&
              subscription?.status === "cancel_scheduled" && (
                <div
                  style={{
                    marginTop: "20px",
                    border: "1px solid #EAF1FA",
                    borderRadius: "8px",
                    display: "flex",
                    gap: 10,
                    justifyContent: "center",
                    alignItems: "center",
                    height: "fit-content",
                    paddingLeft: isMobile ? "5px" : "20px",
                    paddingRight: isMobile ? "10px" : "50px",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                  }}
                >
                  <ExclamationMarkYellow />
                  <p
                    style={{
                      color: "#6C6F71",
                      fontSize: "15px",
                    }}
                  >
                    Your subscription stays active until this billing cycle
                    <br /> ends, then cancels automatically.
                  </p>
                </div>
              )}
          </div>
        </Box>
      </Box>
    </div>
  );
};

export default SubscriptionCard;
